import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "eye",
  "use": "eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"eye\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 199.111111C227.555556 199.111111 28.444444 512 28.444444 512s145.066667 312.888889 483.555556 312.888889c341.333333 0 483.555556-312.888889 483.555556-312.888889S799.288889 199.111111 512 199.111111z m0 512c-110.933333 0-199.111111-88.177778-199.111111-199.111111s88.177778-199.111111 199.111111-199.111111 199.111111 88.177778 199.111111 199.111111-88.177778 199.111111-199.111111 199.111111z\" p-id=\"2059\" /><path d=\"M512 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z\" p-id=\"2060\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/eye.svg
// module id = ekvI
// module chunks = 37